import { render, staticRenderFns } from "./common-share.vue?vue&type=template&id=05a2d423&scoped=true&"
import script from "./common-share.vue?vue&type=script&lang=js&"
export * from "./common-share.vue?vue&type=script&lang=js&"
import style0 from "./common-share.vue?vue&type=style&index=0&id=05a2d423&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a2d423",
  null
  
)

export default component.exports